import styles from './VideoEmbed.module.scss';
import { YouTubeVideoId } from '@customer/config/videos';

export interface VideoEmbedProps {
  title: string;
  videoId: YouTubeVideoId;
  width?: number;
  height?: number;
  privacyEnhancedMode?: boolean;
}

export const VideoEmbed = ({
  title,
  videoId,
  width = 560,
  height = 315,
  privacyEnhancedMode = true,
}: VideoEmbedProps) => {
  // Note: 'rel=0' restricts the play next recommendations to the same channel.
  const src = `https://www.youtube${privacyEnhancedMode && '-nocookie'}.com/embed/${videoId}?rel=0`;

  // Example for default 16:9 aspect ratio: 315 / 560 * 100 = 56.25%
  const aspectRatioPadding = (height / width) * 100;

  return (
    <div
      className={styles.video}
      style={
        {
          '--video-aspect-ratio-padding': `${aspectRatioPadding}%`,
        } as React.CSSProperties
      }
    >
      <div className={styles.video__inner}>
        <iframe
          className={styles.video__embed}
          title={title}
          width={width}
          height={height}
          src={src}
          frameBorder="0"
          allow="encrypted-media"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default VideoEmbed;
